var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-container",class:{
    'base-container--transparent': _vm.transparent,
    'base-container--spacing-x': _vm.spacingX,
    'base-container--spacing-y': _vm.spacingY,
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }